<template>
  <section class="content">
    <!-- Default box -->
    <div
      class="card card-solid"
      :style="{ 'min-height': $store.state.screenHeight - 200 + 'px' }"
    >
      <div class="card-header pb-0">
        <div class="row">
          <div class="form-group row col-sm-3 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right pb-0"
            >เลือกสาขา</label>
            <div class="col-sm-8 pb-0">
              <select
                class="custom-select mr-sm-2 pb-0"
                id="Host"
                v-model="branch"
              >
                <option value="0">-- ทุกสาขา --</option>
                <option
                  v-for="(b, i) in $store.state.branch_list"
                  :key="'branch' + i"
                  :value="b"
                >{{ b.branch_name }}</option>
              </select>
            </div>
          </div>
          <div class="form-group row col-sm-3 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right pb-0"
            >เลือกจุดขาย</label>
            <div class="col-sm-8 pb-0">
              <select
                class="custom-select mr-sm-2 pb-0"
                id="Host"
                v-model="host"
              >
                <option value="0">-- ทุกจุดขาย --</option>
                <option
                  v-for="(h, i) in host_list"
                  :key="'host' + i"
                  :value="h"
                >{{ h.host_name }}</option>
              </select>
            </div>
          </div>
          <div class="form-group row col-sm-3 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right"
            >จากวันที่</label>
            <div class="col-sm-8">
              <a-date-picker
                v-model="startDate"
                :format="'DD/MM/YYYY'"
                style="width: 100%;"
              />
            </div>
          </div>
          <div class="form-group row col-sm-3 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right"
            >ถึงวันที่</label>
            <div class="col-sm-8">
              <a-date-picker
                v-model="endDate"
                :format="'DD/MM/YYYY'"
                style="width: 100%;"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-2"></div>
          <div class="col-sm-3">
            <button
              type="button"
              class="btn btn-success btn-block"
              @click="getReport"
            >
              <i class="fas fa-redo"></i> ประมวลผล
            </button>
          </div>
          <div class="col-sm-3">
            <form
              action="/static/pdf/report_daily.php"
              method="POST"
              target="_blank"
            >
              <input
                type="hidden"
                name="date_start"
                v-model="startDate"
              >
              <input
                type="hidden"
                name="date_end"
                v-model="endDate"
              >
              <input
                type="hidden"
                name="data"
                v-model="form_data"
              >
              <button
                type="submit"
                :disabled="report_data.length < 1"
                class="btn btn-primary btn-block"
              >
                <i class="far fa-file-pdf"></i> บันทึกเป็น PDF
              </button>
            </form>
          </div>
          <div class="col-sm-3">
            <form
              action="/static/excel/report_daily.php"
              method="POST"
              target="_blank"
            >
              <input
                type="hidden"
                name="date_start"
                v-model="startDate"
              >
              <input
                type="hidden"
                name="date_end"
                v-model="endDate"
              >
              <input
                type="hidden"
                name="data"
                v-model="form_data"
              >
              <button
                type="submit"
                :disabled="report_data.length < 1"
                class="btn btn-info btn-block"
              >
                <i class="far fa-file-excel"></i> บันทึกเป็น Excel
              </button>
            </form>
          </div>
        </div>
        <div
          class="text-center pt-3"
          v-if="report_data.length < 1"
        >
          <h5>ไม่มีข้อมูล</h5>
        </div>
        <div
          class="table-responsive-sm mt-3"
          v-for="(c, i) in report_data"
          :key="'c' + i"
          v-show="c.length > 0"
        >
          <h4 class="m-1 p-1">
            สาขา: {{ (c[0])? c[0]['branch_name'] || '-' : '-' }}
            &nbsp;&nbsp;&nbsp;&nbsp; จุดขาย: {{ (c[0])? c[0]['host_code'] || '-' : '-' }}
          </h4>
          <table
            id="sendMoney"
            class="table table-bordered"
            v-for="(c, i) in c"
            :key="'c' + i"
          >
            <tbody>
              <tr class="thead-dark text-left">
                <th colspan="2">
                  เลขที่ปิดการขาย: {{ c.shift_id || '-' }}
                </th>
                <th>
                  ปิดกะโดย: {{ c.close_by || '-' }}
                </th>
                <th>
                  เริ่มต้น: {{ dateFormatAndTime(c.create_time)}} น.
                </th>
                <th>
                  สิ้นสุด: {{ dateFormatAndTime(c.close_time) }} น.
                </th>
              </tr>
              <tr class="thead-light text-center">
                <th colspan="2">รายละเอียด</th>
                <th>เงินสด</th>
                <th>เงินโอน</th>
                <th>รายละเอียด</th>
              </tr>
              <tr>
                <td rowspan="4">ยอดขาย</td>
              </tr>
              <tr>
                <td>ยอดขายสด</td>
                <td class="text-right">{{ numberFormatDecimal(c.sale_cash_amount) }}</td>
                <td class="text-right">{{ numberFormatDecimal(c.sale_bank_amount) }}</td>
                <td></td>
              </tr>
              <tr>
                <td>ยอดขายเชื่อ</td>
                <td class="text-right">{{ numberFormatDecimal(c.rec_cash_amount) }}</td>
                <td class="text-right">{{ numberFormatDecimal(c.rec_bank_amount) }}</td>
                <td class="text-right"></td>
              </tr>
              <tr style="color: #495057;background-color: #e9ecef;border-color: #dee2e6;">
                <td style="font-size: 15px;font-weight: bold;">ยอดขายรวม</td>
                <td class="text-right" style="font-size: 15px;font-weight: bold;">{{ numberFormatDecimal(c.sale_cash_amount + c.rec_cash_amount) }}</td>
                <td class="text-right" style="font-size: 15px;font-weight: bold;">{{ numberFormatDecimal(c.sale_bank_amount + c.rec_bank_amount) }}</td>
                <td></td>
              </tr>
              <tr>
                <td rowspan="7">อื่นๆ</td>
              </tr>
              <tr>
                <td>เงินเปิดกะ</td>
                <td class="text-right">{{ numberFormatDecimal(c.change_begin) }}</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>นำเงินเข้า</td>
                <td class="text-right">{{ numberFormatDecimal(c.in_come_amount) }}</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>(หัก)นำเงินออก</td>
                <td class="text-right">{{ (numberFormatDecimal(c.expense_amount * (-1))) }}</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>รับชำระ</td>
                <td class="text-right">{{ numberFormatDecimal(c.rec_cash_amount) }}</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>ลดหนี้</td>
                <td class="text-right">{{ numberFormatDecimal(c.crd_cash_amount) }}</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>รวมอื่นๆ</td>
                <td class="text-right" style="font-size: 15px;font-weight: bold;">{{ numberFormatDecimal(c.change_begin + c.in_come_amount + c.rec_cash_amount - c.expense_amount - c.crd_cash_amount) }}</td>
                <td></td>
                <td></td>
              </tr>
              <tr style="color: #000000;background-color: #dadada;border-color: #dee2e6;">
                <td colspan="2" style="font-size: 15px;font-weight: bold;">ยอดนำส่งเงิน</td>
                <td class="text-right" style="font-size: 15px;font-weight: bold;">{{ numberFormatDecimal(c.cash_amount) }}</td>
                <td class="text-right" style="font-size: 15px;font-weight: bold;">{{ numberFormatDecimal(c.sale_bank_amount + c.rec_bank_amount) }}</td>
                <td></td>
              </tr>
              <tr style="color: #000000;background-color: #dadada;border-color: #dee2e6;">
                <td colspan="2" style="font-size: 15px;font-weight: bold;">ผลต่าง</td>
                <td class="text-right" style="font-size: 15px;font-weight: bold;">{{ numberFormatDecimal(c.cash_amount - (c.change_begin + c.in_come_amount + c.rec_cash_amount - c.expense_amount - c.crd_cash_amount) - (c.sale_cash_amount + c.rec_cash_amount)) }}</td>
                <td class="text-right" style="font-size: 15px;font-weight: bold;">{{ numberFormatDecimal(c.sale_bank_amount + c.rec_bank_amount) }}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
import moment from 'moment'
import api from '../services/service_report'
import apipos from '../services/service_pos'

export default {
  data () {
    return {
      report_data: [],
      startDate: moment(new Date()),
      endDate: moment(new Date()),
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: '',
      branch: 0,
      host_list: [],
      host: null
    }
  },
  methods: {
    getReport () {
      var branch = 0
      this.report_data = []
      this.form_data = ''
      if (this.branch !== 0) {
        branch = this.branch.id
      }
      var obj = {
        id: branch,
        begin_date: this.dateFormatDMY2(this.startDate),
        end_date: this.dateFormatDMY2(this.endDate),
        company_id: 1,
        host_code: this.host.host_code,
        branch_id: 1
      }
      this.$store.state.isLoading = true
      api.dailyReport(
        sessionStorage.Url,
        this.header,
        obj,
        result => {
          this.$store.state.isLoading = false
          if (result.response === 'success') {
            this.report_data = result.data
            console.log(this.report_data)
            this.form_data = JSON.stringify(this.report_data)
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลรายงานไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    timeFormat (str) {
      return moment(str).format('HH:mm:ss')
    },
    getHost () {
      apipos.getHostShift(
        sessionStorage.Url,
        this.header,
        result => {
          if (result.response === 'success') {
            this.host_list = result.data
            this.host = this.host_list[0]
            // this.getReport()
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลจุดขายไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    }
  },
  mounted () {
    this.checkUser()
    this.getHost()
    this.getBranch()
  }
}
</script>
<style scoped>
.head_table {
  background-color: #ffffad;
}
.head-branch {
  font-size: 18px;
  color: rgb(0, 0, 0);
  font-weight: bold;
}
.table .thead-dark th {
  color: #000000;
  background-color: #ffffad;
  border-color: #ffffad;
}
.table .thead-footer th {
  color: #000000;
  text-align: center;
  background-color: #ffff;
}
</style>



// WEBPACK FOOTER //
// src/views/report_daily.vue